<nav class="pp" aria-label="Paginación">
  <button
    type="button"
    class="pp__btn pp__nav"
    [disabled]="!canPrev"
    (click)="prev()"
    aria-label="Página anterior"
  >
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </button>

  <ng-container *ngFor="let item of pageItems; trackBy: trackByItem">
    <span class="pp__ellipsis" *ngIf="item.ellipsis">&hellip;</span>
    <button
      type="button"
      *ngIf="!item.ellipsis"
      class="pp__btn pp__page"
      [class.pp__page--active]="item.value === page"
      [attr.aria-current]="item.value === page ? 'page' : null"
      (click)="goTo(item.value)"
    >
      {{ item.value }}
    </button>
  </ng-container>

  <button
    type="button"
    class="pp__btn pp__nav"
    [disabled]="!canNext"
    (click)="next()"
    aria-label="Página siguiente"
  >
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </button>
</nav>
